import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { RootState } from "../Store";
import MainLayout from "../Layouts/MainLayout";
import Input from "../Components/Input";

import styles from "../Styles/Forms.module.css";
import useFetch from "../Hooks/useFetch";

function SongEdit() {
  const navigate = useNavigate();
  const token: any = useSelector((state: RootState) => state.auth.token);
  const { id, songId }: any = useParams();
  const [cover, setCover] = useState<any>(null);
  const [name, setName] = useState<any>(null);
  const [artistName, setArtistName] = useState<any>(null);
  const [albumName, setAlbumName] = useState<any>(null);
  const [audio, setAudio] = useState<any>(null);
  const { data, error, loading }: any = useFetch(`/songs/${songId}`, token);

  const uploadData = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();

    if (cover) {
      formData.append("cover", cover);
    }
    
    if (name) {
      formData.append("name", name);
    }
    
    if (artistName) {
      formData.append("artistName", artistName);
    }
    
    if (albumName) {
      formData.append("albumName", albumName);
    }
    
    if (audio) {
      formData.append("audio", audio);
    }
    
    if (id) {
      formData.append("playlistId", id);
    }
    
    
    try {
      await axios.put(`/songs/${songId}`, formData, {
        headers: {
          Authorization: token
        }
      });

      navigate(-1);
    } catch (error: any) {
      console.error("Error: ", error);
      alert(error.response.message);
    }
  };

  useEffect(() => {
    if (data) {
      setName(data.song.name);
      setArtistName(data.song.artistName);
      setAlbumName(data.song.albumName);
    }
  }, [data, setName, setArtistName, setAlbumName, setAudio]);

  return (
    <MainLayout>
      <div className={styles.formContainer}>
        <header>
          <h1>Edit Song</h1>
        </header>
        <form onSubmit={uploadData}>
          <div className={styles.formControl}>
            <Input type="file" name="Cover" state={cover} setState={setCover} />
          </div>
          <div className={styles.formControl}>
            <Input name="Song Name" state={name} setState={setName} />
          </div>
          <div className={styles.formControl}>
            <Input name="Artist Name" state={artistName} setState={setArtistName} />
          </div>
          <div className={styles.formControl}>
            <Input name="Album Name" state={albumName} setState={setAlbumName} />
          </div>
          <div className={styles.formControl}>
            <Input type="file" name="Audio" state={audio} setState={setAudio} />
          </div>
          <div className={styles.formControl}>
            <button className={styles.submitButton}>Edit Song</button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
}

export default SongEdit;
